import { HttpErrorResponse, HttpInterceptorFn, HttpRequest, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { addBreadcrumb, SeverityLevel } from '@sentry/angular';
import { catchError, tap } from 'rxjs/operators';

const sendBreadcrumb = (req: HttpRequest<unknown>, res: HttpResponse<unknown> | HttpErrorResponse, start: number): void => {
  const now = new Date().getTime();
  const duration = (now - start) / 1000;
  const { headers, status } = res;
  const { method, url } = req;

  addBreadcrumb({
    category: 'xhr',
    data: { method, url, status_code: status, duration, traceId: headers.get('trace-id') },
    timestamp: now / 1000,
    type: 'https',
    level: res instanceof HttpErrorResponse ? ('error' as SeverityLevel) : ('info' as SeverityLevel)
  });
};

export const sentryInterceptor: HttpInterceptorFn = (req, next) => {
  const start = new Date().getTime();

  return next(req).pipe(
    tap((res) => {
      if (res instanceof HttpResponse) {
        sendBreadcrumb(req, res, start);
      }
    }),
    catchError((res: unknown) => {
      if (res instanceof HttpErrorResponse && res.status !== HttpStatusCode.Unauthorized) {
        sendBreadcrumb(req, res, start);
      }

      throw res;
    })
  );
};
